import { isNullish } from "@theorgchartdev/storybook";

export const decodeColorObject = color => {
  if (!color) {
    return null;
  }

  if (typeof color === "string") {
    return color;
  }

  return [color.start, color.end];
};

export const encodeColorObject = (color, gradientColor) => {
  if (!color) {
    return null;
  }

  if (!gradientColor) {
    return color;
  }

  return {
    mode: "linear",
    angle: 180,
    start: color,
    end: gradientColor
  };
};

export const isHexColor = color => {
  return typeof color === "string";
};

export const isGradientColor = color => {
  return !isNullish(color) && typeof color === "object" && "mode" in color;
};

const compareColorStops = (stopsA, stopsB) => {
  if (!Array.isArray(stopsA) || !Array.isArray(stopsB)) {
    return stopsA === stopsB;
  }

  if (stopsA.length !== stopsB.length) {
    return false;
  }

  return stopsA.every((stop, i) => {
    return stop.color === stopsB[i].color && stop.position === stopsB[i].position;
  });
};

export const areColorsEqual = (colorA, colorB) => {
  if (isHexColor(colorA) && isHexColor(colorB)) {
    return colorA.toUpperCase() === colorB.toUpperCase();
  }

  if (isGradientColor(colorA) && isGradientColor(colorB)) {
    return (
      colorA.mode === colorB.mode &&
      colorA.angle === colorB.angle &&
      colorA.position === colorB.position &&
      colorA.start === colorB.start &&
      colorA.end === colorB.end &&
      compareColorStops(colorA.stops, colorB.stops)
    );
  }

  return false;
};
